/* eslint-disable @typescript-eslint/no-explicit-any */
import { axiosClient } from '../helpers/axiosClient';

export const ParamsConfigServices = {

  /* ***======= Company's Template service =======*** */
  // Get params confi
  getAllParamsConfig: () => {
    const url = `api/config-ai`;
    return axiosClient.get(url);
  },

  // Update params config
  updateParamsConfigById: (payload: {id: number, data: any}) => {
    const url = `api/config-ai/${payload.id}`;
    return axiosClient.put(url, payload.data);
  },

};
